// @owners { team: patients-team }
import { COLORS, SIZES } from '@alto/design-library-tokens';
import { Border, Icon, Row } from '@alto/design-system';
import React from 'react';

/**
 * Display a pill icon with background color. Used as a placeholder for medications without an image.
 */
export const Pill = () => {
  return (
    <Border
      radius="MD"
      color={COLORS.PALETTE.PRIMARY.LIGHTER}
    >
      <Row
        center
        backgroundColor={COLORS.PALETTE.PRIMARY.LIGHTER}
        style={{ width: SIZES.ILLUSTRATION.SM.value, height: SIZES.ILLUSTRATION.SM.value }}
      >
        <Icon name="capsule" />
      </Row>
    </Border>
  );
};
